import { ReactNode } from 'react';

import { ActivatePerkPopup } from './activate-perk-popup';
import { CancelPerkCreationPopup } from './cancel-perk-creation-popup';
import { CancelPerkEditingPopup } from './cancel-perk-editing-popup';
import { DeactivatePerkPopup } from './deactivate-perk-popup';
import { DeletePerkPopup } from './delete-perk-popup';

export enum PopupType {
  ACTIVATE_PERK = 'delete-guest',
  CANCEL_PERK_CREATION = 'cancel-invitation',
  CANCEL_PERK_EDITING = 'grant-access',
  DEACTIVATE_PERK = 'convert-to-stakeholder',
  DELETE_PERK = 'resend-invitation',
}

export const popupTypeComponent: Record<PopupType, ReactNode> = {
  [PopupType.ACTIVATE_PERK]: <ActivatePerkPopup />,
  [PopupType.CANCEL_PERK_CREATION]: <CancelPerkCreationPopup />,
  [PopupType.CANCEL_PERK_EDITING]: <CancelPerkEditingPopup />,
  [PopupType.DEACTIVATE_PERK]: <DeactivatePerkPopup />,
  [PopupType.DELETE_PERK]: <DeletePerkPopup />,
};
